module.exports = __webpack_public_path__ + "assets/img/log-out@1,5x.e1b3d2db.svg";